// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"999a0887","198":"93e965be","449":"c7adc1a3","453":"e1bffba9","774":"6b6ded67","869":"f1dd4b53","936":"cb3462a0"}[chunkId] + ".chunk.js";
};